<template>
  <div class="flex gap-2 items-center">
    <p v-if="label" class="font-bold">{{ label }}</p>
    <div class="flex items-center bg-white w-fit border rounded-full cursor-pointer" :class="borderClass" @click="update">
      <div class="relative flex items-center m-1 py-2 px-5 rounded-full transition-all duration-300">
        <i class="absolute left-0 transition-transform duration-300 fa-regular fa-circle" :class="[iconClass, modelValue ? 'translate-x-6' : 'translate-x-0']"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:modelValue'])

const update = () => {
  emit('update:modelValue', !props.modelValue)
}
</script>
